<a
  [routerLink]="link"
  class="bg-lightGrayish flex h-[5.5rem] cursor-pointer flex-col border border-transparent p-4 font-semibold duration-300 ease-out hover:border-[#E6AE48] max-lg:items-center max-lg:text-xs lg:h-28"
>
  <span>{{ icon }}</span>
  <span>
    {{ firstText }} <br />
    <span [ngClass]="secondText === 'placeholder' ? 'opacity-0' : 'opacity-100'" class="flex truncate">{{
      secondText
    }}</span>
  </span>
</a>
